import { combineReducers } from 'redux';
import authReducer from '../auth/reducer';
import profileReducer from '../profile/reducer';
import statsReducer from '../reading-stats/reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  stats: statsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/root.reducer.ts